import { Add } from '@mui/icons-material';
import MyRequests from 'pages/main/client-pool/MyRequests';
import NewRequests from 'pages/main/client-pool/NewRequests';
import SavedRequests from 'pages/main/client-pool/SavedRequests';
import { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'util/Constants';
import { classNames } from 'util/Funcs';

const tabs = [{ name: 'New Requests' }, { name: 'Saved Requests' }, { name: 'My Requests' }];

export default function Tabs() {
    const [currentTab, setCurrentTab] = useState('New Requests');
    const navigate = useNavigate();

    const tabContentMap: Record<string, JSX.Element> = {
        'New Requests': <NewRequests setCurrentTab={setCurrentTab} />,
        'Saved Requests': <SavedRequests />,
        'My Requests': <MyRequests />,
    };

    const renderContent = () => tabContentMap[currentTab];

    return (
        <Fragment>
            <div className="px-8 sm:px-6 lg:px-12 py-3 bg-white">
                <div className="flex md:justify-between sm:justify-center">
                    <div className="border-b border-gray-200">
                        <nav aria-label="Tabs" className="-mb-px flex space-x-8">
                            {tabs.map((tab) => (
                                <button
                                    key={tab.name}
                                    onClick={() => setCurrentTab(tab.name)}
                                    aria-current={currentTab === tab.name ? 'page' : undefined}
                                    className={classNames(
                                        currentTab === tab.name
                                            ? 'border-indigo-500 text-indigo-600'
                                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                        'whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium',
                                    )}
                                >
                                    {tab.name}
                                </button>
                            ))}
                        </nav>
                    </div>
                    <div className="self-center">
                        <div className=" border-my-blue bg-my-blue/5 rounded-md border">
                            <button
                                className=" text-my-blue px-10 h-12 hidden md:flex rounded-md  items-center gap-2 cursor-pointer"
                                onClick={() => navigate(ROUTES.ADD_REQUEST)}
                            >
                                <Add />
                                Add Request
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" px-8 sm:px-6 lg:px-12 bg-white/80">{renderContent()}</div>
        </Fragment>
    );
}
